import { createSlice } from "@reduxjs/toolkit";

//Assume the initial last updated time as 11 pm of the previous day
const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
yesterday.setHours(23, 0, 0, 0)

const initialState = {
  pageLoader: null,
  pageLastUpdatedTime: yesterday.getTime(),
  show: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setPageLoader: (state, action) => {
      return {
        ...state,
        pageLoader: action.payload,
      };
    },
    setShowLoader: (state, action) => {
      return {
        ...state,
        show: action.payload,
      };
    },
    setPageLastUpdatedTime: (state, action) => {
      return {
        ...state,
        pageLastUpdatedTime: action.payload,
      }
    }
  },
});

export const { setPageLoader, 
  setShowLoader,
  setPageLastUpdatedTime } = loaderSlice.actions;

export default loaderSlice.reducer;
